export const OFFER_SEARCH = 'offerSearch';
export const OFFER_GET = 'offerGet';
export const OFFER_ADD = 'offerAdd';
export const OFFER_ADD_NDC = 'offerAddNDC';
export const OFFER_REMOVE_NDC = 'offerRemoveNDC';
export const OFFER_ADD_STATE_EXCLUSION = 'offerAddStateExclusion';
export const OFFER_REMOVE_STATE_EXCLUSION = 'offerRemoveStateExclusion';
export const OFFER_ADD_SEGMENT = 'offerAddSegment';
export const OFFER_REMOVE_SEGMENT = 'offerRemoveSegment';
export const OFFER_SAVE_SEGMENT = 'offerSaveSegment';
export const OFFER_REQUESTAPPROVAL = 'offerRequestApproval';
export const OFFER_APPROVE = 'offerApprove';
export const OFFER_PUBLISH = 'offerPublish';
export const OFFER_CANCEL = 'offerCancel';
export const OFFER_SAVE = 'offerSave';
export const OFFER_CREATE = 'offerCreate';
export const OFFER_LOAD_GLOBAL_PRODUCT_LISTS = 'offerLoadGlobalProductLists';
export const OFFER_LOAD_GLOBAL_LISTS = 'offerLoadGlobalLists';



// WEBPACK FOOTER //
// ./src/store/offer/actions.type.js